import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { splitAuditDateTime } from './rbacAuditHistoryHelpers'
import { auditDatePrimarySx, auditDateSecondarySx } from './rbacAuditHistoryConstants'

export default function RbacAuditDateCell({ createdAt }) {
  const { date, time } = splitAuditDateTime(createdAt)

  return (
    <Box>
      <Typography sx={auditDatePrimarySx}>{date}</Typography>
      {time ? <Typography sx={auditDateSecondarySx}>{time}</Typography> : null}
    </Box>
  )
}
